 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-Money_settlement-vue":"view-Money_settlement-vue","view-Privacy_policy-vue":"view-Privacy_policy-vue","view-Specific_business-vue":"view-Specific_business-vue","view-Terms_of_service-vue":"view-Terms_of_service-vue","view-based_fund_settlement_law-vue":"view-based_fund_settlement_law-vue","view-bosyuu-vue":"view-bosyuu-vue","view-character-vue":"view-character-vue","view-comics-vue":"view-comics-vue","view-comics02-vue":"view-comics02-vue","view-components-container-vue":"view-components-container-vue","view-contact-vue":"view-contact-vue","view-contact_1-vue~view-contact_2-vue~view-contact_3-vue~view-contact_4-vue~view-serial_code-vue":"view-contact_1-vue~view-contact_2-vue~view-contact_3-vue~view-contact_4-vue~view-serial_code-vue","view-contact_1-vue~view-contact_2-vue~view-contact_3-vue":"view-contact_1-vue~view-contact_2-vue~view-contact_3-vue","view-contact_1-vue":"view-contact_1-vue","view-contact_2-vue":"view-contact_2-vue","view-contact_3-vue":"view-contact_3-vue","view-contact_4-vue":"view-contact_4-vue","view-serial_code-vue":"view-serial_code-vue","view-contact_wrap-vue":"view-contact_wrap-vue","view-fankit-Guidelines-vue":"view-fankit-Guidelines-vue","view-fankit-Precautions-vue":"view-fankit-Precautions-vue","view-fankit-vue":"view-fankit-vue","view-faq-vue":"view-faq-vue","view-help-alert-vue":"view-help-alert-vue","view-help-index-vue":"view-help-index-vue","view-help-list-vue":"view-help-list-vue","view-help-zoomer-vue":"view-help-zoomer-vue","view-news-vue":"view-news-vue","view-newsJump-vue":"view-newsJump-vue","view-newsJump_context-vue":"view-newsJump_context-vue","view-newsjumps-vue":"view-newsjumps-vue","view-subscribe-vue":"view-subscribe-vue","view-system-vue":"view-system-vue"}[chunkId]||chunkId) + "." + {"view-Money_settlement-vue":"75e54343","view-Privacy_policy-vue":"62e4a39b","view-Specific_business-vue":"ac23195a","view-Terms_of_service-vue":"2ee96cf6","view-based_fund_settlement_law-vue":"8f92ac24","view-bosyuu-vue":"f68d37a0","view-character-vue":"4b83fa09","view-comics-vue":"3c42438f","view-comics02-vue":"79319cc3","view-components-container-vue":"c49ce390","view-contact-vue":"3aa97b79","view-contact_1-vue~view-contact_2-vue~view-contact_3-vue~view-contact_4-vue~view-serial_code-vue":"b9b15894","view-contact_1-vue~view-contact_2-vue~view-contact_3-vue":"7ceea293","view-contact_1-vue":"6c3e6f69","view-contact_2-vue":"6971a244","view-contact_3-vue":"66996814","view-contact_4-vue":"35e79372","view-serial_code-vue":"9ee2c077","view-contact_wrap-vue":"06a84b77","view-fankit-Guidelines-vue":"f38e7971","view-fankit-Precautions-vue":"4463dd03","view-fankit-vue":"9843d6c4","view-faq-vue":"e6f95b3b","view-help-alert-vue":"546dfbfa","view-help-index-vue":"ce1fd899","view-help-list-vue":"2e000eb7","view-help-zoomer-vue":"6dbdb11d","view-news-vue":"61fdcfe4","view-newsJump-vue":"232a176e","view-newsJump_context-vue":"759828e8","view-newsjumps-vue":"cbf9403f","view-subscribe-vue":"091e2edd","view-system-vue":"076bffaf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-Money_settlement-vue":1,"view-Privacy_policy-vue":1,"view-Specific_business-vue":1,"view-Terms_of_service-vue":1,"view-based_fund_settlement_law-vue":1,"view-bosyuu-vue":1,"view-character-vue":1,"view-comics-vue":1,"view-comics02-vue":1,"view-components-container-vue":1,"view-contact-vue":1,"view-contact_1-vue~view-contact_2-vue~view-contact_3-vue~view-contact_4-vue~view-serial_code-vue":1,"view-contact_1-vue~view-contact_2-vue~view-contact_3-vue":1,"view-contact_1-vue":1,"view-contact_2-vue":1,"view-contact_3-vue":1,"view-contact_4-vue":1,"view-serial_code-vue":1,"view-fankit-Guidelines-vue":1,"view-fankit-Precautions-vue":1,"view-fankit-vue":1,"view-faq-vue":1,"view-help-alert-vue":1,"view-help-index-vue":1,"view-help-list-vue":1,"view-help-zoomer-vue":1,"view-news-vue":1,"view-newsJump-vue":1,"view-newsJump_context-vue":1,"view-newsjumps-vue":1,"view-subscribe-vue":1,"view-system-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-Money_settlement-vue":"view-Money_settlement-vue","view-Privacy_policy-vue":"view-Privacy_policy-vue","view-Specific_business-vue":"view-Specific_business-vue","view-Terms_of_service-vue":"view-Terms_of_service-vue","view-based_fund_settlement_law-vue":"view-based_fund_settlement_law-vue","view-bosyuu-vue":"view-bosyuu-vue","view-character-vue":"view-character-vue","view-comics-vue":"view-comics-vue","view-comics02-vue":"view-comics02-vue","view-components-container-vue":"view-components-container-vue","view-contact-vue":"view-contact-vue","view-contact_1-vue~view-contact_2-vue~view-contact_3-vue~view-contact_4-vue~view-serial_code-vue":"view-contact_1-vue~view-contact_2-vue~view-contact_3-vue~view-contact_4-vue~view-serial_code-vue","view-contact_1-vue~view-contact_2-vue~view-contact_3-vue":"view-contact_1-vue~view-contact_2-vue~view-contact_3-vue","view-contact_1-vue":"view-contact_1-vue","view-contact_2-vue":"view-contact_2-vue","view-contact_3-vue":"view-contact_3-vue","view-contact_4-vue":"view-contact_4-vue","view-serial_code-vue":"view-serial_code-vue","view-contact_wrap-vue":"view-contact_wrap-vue","view-fankit-Guidelines-vue":"view-fankit-Guidelines-vue","view-fankit-Precautions-vue":"view-fankit-Precautions-vue","view-fankit-vue":"view-fankit-vue","view-faq-vue":"view-faq-vue","view-help-alert-vue":"view-help-alert-vue","view-help-index-vue":"view-help-index-vue","view-help-list-vue":"view-help-list-vue","view-help-zoomer-vue":"view-help-zoomer-vue","view-news-vue":"view-news-vue","view-newsJump-vue":"view-newsJump-vue","view-newsJump_context-vue":"view-newsJump_context-vue","view-newsjumps-vue":"view-newsjumps-vue","view-subscribe-vue":"view-subscribe-vue","view-system-vue":"view-system-vue"}[chunkId]||chunkId) + "." + {"view-Money_settlement-vue":"3c5b3e6e","view-Privacy_policy-vue":"22590961","view-Specific_business-vue":"22590961","view-Terms_of_service-vue":"22590961","view-based_fund_settlement_law-vue":"22590961","view-bosyuu-vue":"0db30ef6","view-character-vue":"b3742afb","view-comics-vue":"f8581df6","view-comics02-vue":"f8ea78f2","view-components-container-vue":"22590961","view-contact-vue":"ac51a7d8","view-contact_1-vue~view-contact_2-vue~view-contact_3-vue~view-contact_4-vue~view-serial_code-vue":"fbd20666","view-contact_1-vue~view-contact_2-vue~view-contact_3-vue":"e29a280a","view-contact_1-vue":"25f0a1b9","view-contact_2-vue":"f34358ec","view-contact_3-vue":"7725c243","view-contact_4-vue":"0b2ca13e","view-serial_code-vue":"1011928b","view-contact_wrap-vue":"31d6cfe0","view-fankit-Guidelines-vue":"1b781d62","view-fankit-Precautions-vue":"d8594624","view-fankit-vue":"2e91974c","view-faq-vue":"0111ca21","view-help-alert-vue":"e49a7c98","view-help-index-vue":"2f534607","view-help-list-vue":"94f648ae","view-help-zoomer-vue":"ab5adbe0","view-news-vue":"a382d392","view-newsJump-vue":"4287000e","view-newsJump_context-vue":"bb458e93","view-newsjumps-vue":"281d1717","view-subscribe-vue":"88b9a24f","view-system-vue":"7a73f601"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://webusstatic.yo-star.com/bluearchive_jp_web/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
